var render = function render(_c,_vm){return (_vm.props.value)?_c('span',[_vm._v(" "+_vm._s(Number(_vm.props.value))+" ")]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }